// @ts-ignore
import featherlight from 'featherlight'

featherlight()
